import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import AppLayout from '../../../../components/layout/layout'
import { Row, Tabs } from 'antd'
import AdultProfileHeader from './Header'
import Notes from '../NotesComp/Notes'
import Spinner from 'components/Spinner'
import AdultsBasicInfo from '../../Profiles/AdultProfile/BasicInformation/index'
import { useGetAdultById } from 'api/family/adult'
import { adultStore } from 'state/family/adult'
import CreateAdult from '../FamilyProfile/FamilyMembers/Modals/AuthorizedAdult/CreateAdult'
import Events from './AdultEvents/Events'
import AdultMedia from './Media/AdultMedia'
import Documents from './Documents/Documents'
import { useGetSearchParams } from 'hooks/useGetSearchParams'
const { TabPane } = Tabs

const AdultProfile = () => {
  const history = useHistory()
  let { id }: { id: string } = useParams()
  const { tab } = useGetSearchParams(['tab'])
  const { adultCreationModal } = adultStore(store => ({
    adultCreationModal: store.adultCreationModal,
  }))

  const handleTabChange = (key: string) => {
    if (key === 'events') {
      history.push(`?tab=events&page=1&limit=20`)
    } else {
      history.push(`?tab=${key}`)
    }
  }

  const { isLoading, data, refetch, isFetching } = useGetAdultById(id)

  useEffect(() => {
    refetch()
  }, [])
  return (
    <AppLayout id={id}>
      <div className="container bg-grey">
        {isLoading || isFetching ? (
          <div className="h-100vh flex justify-center align-center">
            <Spinner />
          </div>
        ) : (
          <>
            <AdultProfileHeader data={data} refetch={refetch} />
            <Row>
              <Tabs
                activeKey={tab ?? 'basic-info'}
                style={{ width: '100%', height: '100%' }}
                className="bg-white profile-tabs"
                onChange={handleTabChange}
              >
                <TabPane tab="Basic Info" key="basic-info">
                  <AdultsBasicInfo parent={data} refetch={refetch} />
                </TabPane>
                <TabPane tab="Events" key="events">
                  <Events adultId={id} />
                </TabPane>
                <TabPane tab="Media" key="media">
                  <AdultMedia />
                </TabPane>
                <TabPane tab="Documents" key="documents">
                  <Documents />
                </TabPane>
                <TabPane tab="Notes" key="notes">
                  <Notes id={id} familyId={data?.familyId} />
                </TabPane>
              </Tabs>
            </Row>
          </>
        )}
      </div>
      {adultCreationModal && <CreateAdult familyId={data.familyId} />}
    </AppLayout>
  )
}
export default AdultProfile
